import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, HeartCrack, Sparkles, XCircle } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function Story() {
  return <div className="bg-brand-ivory py-24" data-id="element-223">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-224">
        {/* SECCIÓN 1: HOOK & AGITACIÓN */}
        <motion.section initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="mb-24" data-id="element-225">
          <div className="flex justify-center mb-8" data-id="element-226">
            <AlertCircle className="text-brand-gold w-10 h-10 opacity-50" data-id="element-227" />
          </div>
          <div className="space-y-6 text-lg text-brand-charcoal/80 leading-relaxed text-center" data-id="element-228">
            <p className="font-serif text-2xl text-brand-charcoal mb-8" data-id="element-229">
              ¿Cuántas veces pusiste todo tu esfuerzo en un trabajo de uñas… y a
              los pocos días ya se estaba levantando?
            </p>
            <p data-id="element-230">
              ¿Cuántas veces cobraste barato porque sentiste que "todavía no
              eras suficientemente buena" para cobrar lo que querías?
            </p>
            <p data-id="element-231">
              ¿Cuántas veces viste a otra manicurista con la agenda llena y te
              preguntaste qué tiene ella que vos no tenés?
            </p>
            <div className="py-6" data-id="element-232">
              <div className="w-16 h-px bg-brand-gold/30 mx-auto" data-id="element-233"></div>
            </div>
            <p className="font-medium text-brand-charcoal" data-id="element-234">
              Spoiler: no es suerte. No es que ella nació con el don. No es que
              vive en Montevideo y allá "hay más mercado".
            </p>
            <p className="text-xl font-serif text-brand-gold italic mt-4" data-id="element-235">
              Es que alguien le enseñó bien.
            </p>
            <p className="font-medium mt-4" data-id="element-236">
              Y hoy, por primera vez en Uruguay, existe un espacio donde eso
              también te puede pasar a vos.
            </p>
          </div>
        </motion.section>

        {/* SECCIÓN 2: AMPLIFICACIÓN DEL DOLOR */}
        <motion.section initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="mb-24 bg-brand-cream p-8 md:p-12 rounded-2xl relative" data-id="element-237">
          <HeartCrack className="absolute -top-5 -left-5 text-brand-rose w-12 h-12 opacity-40 rotate-[-15deg]" data-id="element-238" />
          <h2 className="text-3xl font-serif text-brand-charcoal mb-8 text-center" data-id="element-239">
            Seamos honestas por un momento.
          </h2>

          <div className="space-y-6 text-brand-charcoal/80 leading-relaxed" data-id="element-240">
            <p data-id="element-241">
              Aprender manicura sola, con tutoriales, con kits baratos y videos
              de YouTube es frustrante.
            </p>
            <p data-id="element-242">
              Porque nadie te corrige cuando aplicás el gel mal. Nadie te dice
              que ese paso que saltaste es exactamente el que hace que la uña
              dure. Nadie te explica por qué con unas clientas te sale perfecto
              y con otras parece que todo falla.
            </p>
            <p className="font-medium text-brand-charcoal" data-id="element-243">
              Y lo peor no es que el trabajo no quede bien. Lo peor es lo que
              eso te hace sentir a vos.
            </p>
            <p data-id="element-244">
              Empezás a dudar. A cobrar menos de lo que vale tu tiempo. A decir
              "todavía me falta aprender" cuando en realidad lo que te falta es
              el sistema correcto, no el talento.
            </p>
            <p data-id="element-245">
              Mientras tanto, hay clientas en Paysandú buscando una manicurista
              de confianza. Hay mujeres que pagarían bien por uñas que duren de
              verdad. Hay un mercado esperándote.
            </p>
            <p className="font-serif text-xl text-center text-brand-goldDark pt-4" data-id="element-246">
              Y vos seguís ahí, paralizada, esperando sentirte "lista".
            </p>
          </div>
        </motion.section>

        {/* SECCIÓN 3: EL FUTURO QUE QUERÉS */}
        <motion.section initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="mb-24" data-id="element-247">
          <div className="text-center mb-12" data-id="element-248">
            <Sparkles className="text-brand-gold w-8 h-8 mx-auto mb-4" data-id="element-249" />
            <h2 className="text-4xl font-serif text-brand-charcoal" data-id="element-250">
              Imaginá esto.
            </h2>
          </div>

          <div className="space-y-8" data-id="element-251">
            <div className="flex gap-6 items-start" data-id="element-252">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-brand-blush/30 flex items-center justify-center text-brand-goldDark font-serif text-xl" data-id="element-253">
                1
              </div>
              <p className="text-lg text-brand-charcoal/80 pt-2" data-id="element-254">
                Abrís tu agenda del mes y está llena. No porque hagas
                descuentos. Sino porque tus clientas volvieron, te recomendaron,
                y encima te etiquetaron en Instagram.
              </p>
            </div>
            <div className="flex gap-6 items-start" data-id="element-255">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-brand-blush/30 flex items-center justify-center text-brand-goldDark font-serif text-xl" data-id="element-256">
                2
              </div>
              <p className="text-lg text-brand-charcoal/80 pt-2" data-id="element-257">
                Imaginá cobrar lo que querés sin culpa. Porque sabés que lo que
                entregás vale cada peso.
              </p>
            </div>
            <div className="flex gap-6 items-start" data-id="element-258">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-brand-blush/30 flex items-center justify-center text-brand-goldDark font-serif text-xl" data-id="element-259">
                3
              </div>
              <p className="text-lg text-brand-charcoal/80 pt-2" data-id="element-260">
                Imaginá terminar un trabajo, mirarlo, y sentir esa satisfacción
                profunda de decir:{' '}
                <span className="font-serif italic text-brand-charcoal" data-id="element-261">
                  "esto lo hice yo, y está perfecto."
                </span>
              </p>
            </div>
          </div>

          <p className="text-center text-xl font-medium text-brand-charcoal mt-12" data-id="element-262">
            No es un sueño lejano. Es exactamente lo que están viviendo las
            alumnas de Avril Balbis hoy.
          </p>
        </motion.section>

        {/* SECCIÓN 4: POR QUÉ TODO LO QUE PROBASTE ANTES NO FUNCIONÓ */}
        <motion.section initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="border border-brand-rose/30 rounded-2xl p-8 md:p-12" data-id="element-263">
          <div className="flex justify-center mb-6" data-id="element-264">
            <XCircle className="text-brand-rose w-8 h-8" data-id="element-265" />
          </div>
          <h2 className="text-2xl md:text-3xl font-serif text-brand-charcoal text-center mb-8" data-id="element-266">
            La mayoría de los cursos de manicura te enseñan pasos.
            <br data-id="element-267" />
            <span className="text-brand-gold italic" data-id="element-268">
              Avril te enseña a pensar.
            </span>
          </h2>

          <div className="space-y-6 text-brand-charcoal/80 text-center" data-id="element-269">
            <p data-id="element-270">
              Hay una diferencia enorme entre saber qué hacer y entender por qué
              funciona.
            </p>
            <p data-id="element-271">
              Los tutoriales de YouTube no pueden verte las manos. Los cursos
              grabados no pueden corregirte en tiempo real. Las kits baratos te
              dan resultados baratos, y después creés que el problema sos vos.
            </p>
            <p className="text-xl font-serif text-brand-charcoal py-4" data-id="element-272">
              No sos vos. Es el método.
            </p>
            <p data-id="element-273">
              Y el método equivocado no solo te hace perder clientas. Te hace
              perder confianza. Y eso es lo más caro de todo.
            </p>
          </div>
        </motion.section>
      </div>
    </div>;
}